<template>
  <v-card>
    <v-fab-transition>
      <v-btn v-show="!scrolledToBottom" color="primary" dark fixed bottom right fab v-on:click="$emit('add-score')">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-card>
</template>
<script>
export default {
  data() {
    return { scrolledToBottom: false };
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        this.scrolledToBottom =
          Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) +
            window.innerHeight ===
          document.documentElement.offsetHeight;
      };
    },
  },
  mounted() {
    this.scroll();
  },
};
</script>
